import React from 'react';
import PageLayout from './PageLayout';

/**
 * The three policy pages are one layout with different prose: a quiet
 * header, then a single measure of body copy. No decoration — a legal
 * document is not a surface for orbs, and the system forbids gradients
 * behind paragraph text.
 */
const LegalPage = ({ title, description, path, heading, updated, children }) => (
  <PageLayout title={title} description={description} path={path}>
    <section className="border-b border-line bg-surface pt-[72px]">
      <div className="container-page py-14 text-center">
        <span className="eyebrow accent-1">Legal</span>
        <h1 className="mt-5 text-3xl font-bold tracking-tight text-content sm:text-4xl">
          {heading}
        </h1>
        <p className="mt-4 text-sm text-content-muted">Last updated: {updated}</p>
      </div>
    </section>

    <section className="section section--muted">
      <div className="container-page">
        <div className="card mx-auto max-w-3xl !p-8 sm:!p-10">{children}</div>
      </div>
    </section>
  </PageLayout>
);

/** One numbered clause: a ruled heading and its paragraphs. */
export const LegalSection = ({ title, children }) => (
  <div className="mb-8 last:mb-0">
    <h2 className="mb-3 border-b border-line pb-2 text-xl font-bold text-content">{title}</h2>
    <div className="space-y-3 leading-relaxed text-content-muted">{children}</div>
  </div>
);

export default LegalPage;
